// extracted by mini-css-extract-plugin
module.exports = {"search_wrapper":"news_search_search_wrapper__VZAKj","input_wrapper":"news_search_input_wrapper__CIh0I","search_icon":"news_search_search_icon__KW7gb"};